import { Observable } from 'rxjs';
import { AccountMap } from '../../../models/AccountMap';
import { Acc_Txn_Service } from '../../../services/Acc_Txn_Servcies';
//import {InvoiceService} from;
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { AccountMappingService } from '../../../services/AccountMappingService';
import { Global } from '../../global';
import { GL_Child } from '../../../models/GL_Child';
//import { JournalEntry } from './../../../models/Txn_JournalEntry';
import { Component, OnInit } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DiscountService } from '../../../services/DiscountService';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import * as moment from 'jalali-moment';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { map, startWith } from 'rxjs/operators';
import { mergeMap } from 'rxjs/operators';
import { Txn_Invoice } from '../../../models/Txn_Invoice';
import { RequireMatch } from '../../utils/requireMatch';
import { InvoiceService } from '../../../services/Acc_InvoiceService';
import { MatSelectChange } from "@angular/material/select";
import { JournalEntry } from '../../../models/Txn_JournalEntry';
import { DariCalendarService } from '../../../services/DariCalendar';
import { FeeService } from '../../../services/FeeService';
import { Fee } from '../../../models/Fee';
import { PaidFeesModalComponent } from './paid-fees-modal/paid-fees-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { FixAmount } from '../../../models/fix-amount';
import { Router } from '@angular/router';
@Component({
  selector: 'app-student-invoice',
  templateUrl: './student-invoice.component.html',
  styleUrls: ['./student-invoice.component.css']
})
export class StudentInvoiceComponent implements OnInit {
  form: FormGroup;
  ArrLabels: any;
  labels: any = {};
  ArrLabels1: any;
  StudentAccounts: any;
  txn_result: any;
  arr_results: any = {};
  studentDetails: any = {};
  glCode: string;
  ArrAccountMaps: any;
  MasterAccDR: any;
  DebitAccounts: any;
  selectedAccountName: any;
  pdate = moment(new Date()).format('jYYYY-jMM-jDD');    // Dari date
  printVariables: any = {};
  invoiceTypes: any = {};
  selectedInvoiceType: string;
  isFeeSemester: boolean = false;
  invoiceList: any = {};
  isPrintable: boolean;
  prntselectedAccountName: any;
  prntSelectedBankAccount: string;
  prntSelectedBankNumber: string;
  studentName: any = {};
  studentID: string;
  feeAmount: string;
  totalPaid: number;
  feeGet: any;
  insNumber = [1, 2, 3, 4, 5, 6];  // months for this project
  totalUnpaid: number; years = new Array();
  oldFees: any = {}; // = invoices
  fee: Fee = { feeID: "undefined", feeAmount: "undefined", fieldID: "undefined", season: "undefined", semester: "0", year: "undefined", departmentName: "", studentId: "", newSemester: 0, isRepeatedSemeter: false, repeatSemesterSerie: 1, branchId: 0, branchName: '' }
  txn_DR: JournalEntry = {
    module: "FT",
    trn_ref_no: "",
    event_sr_no: 1,
    eventName: "INIT",
    ac_entry_sr_no: 0,
    ac_branch: "000",
    GL_Code: "",
    drcr_ind: "DR",
    trn_code: "AAT",
    trn_amount: null,
    trn_date: new Date(),
    value_date: new Date(),
    financial_cycle: "",
    period_code: "",
    batch_no: "1111",
    MakerID: "test",
    CheckerID: "test",
    auth_stat: "A",
    delete_stat: "",
    product: "REIN",
    external_ref_no: "",
    entry_seq_no: 0,
    remarks: "",
    userId: "",
    documentNo: "",
    branchId: 0,
    statusId: 0,
    isPrint: false,
    branchTitle: '',
    statusTitle: '',
    
  }
  txn_Invoice: Txn_Invoice = {
    inv_no: 0,
    inv_amount: 0,
    relatedAccount: "",
    discount_amount: 0,
    payable_amount: 0,
    makerID: "test",
    checkerID: "test",
    clearDate: null,
    clear_status: "N",
    authStat: "A",
    clearBankRefNO: "",
    issueDate: new Date(),
    expiryDate: new Date(),
    semester: 0,
    trn_ref_clear: "",
    trn_ref_issue: "",
    issue_remark: "",
    invoiceType: "",
    invoiceDesc: "",
    year: "",
    season: '0',
    installmentNumber: 0,
    installmentNumbers: '',
    isRepeatSemester: false,
    userId: '',
    branchId: '',
    discountValue: 0,
    repeatSemesterSerie: 1,
    termId :0
  }
  filteredOptions: Observable<string[]>;
  paymentInMonth: string = "";
  paymentByDiscount: string = "";
  IsRepeatSemester: boolean = false;
  RepeatSemesterSerie: number = 1;

  constructor(
    private GL_MasterService: GL_MasterService,
    private global: Global,
    private UtilityService: UtilityService,
    private Txn_DE_Service: Acc_Txn_Service,
    public snackBar: MatSnackBar,
    public datepipe: DatePipe,
    private DariCalendar: DariCalendarService,
    private AccountMapService: AccountMappingService,
    private DiscountService: DiscountService,
    private InvoiceService: InvoiceService,
    private router: Router,
    private FeeService: FeeService, public dialog: MatDialog
  ) { }

  resetTrns() {
    // fill the print varaibales
    this.printVariables['trn_amount'] = this.txn_Invoice.inv_amount;
    this.printVariables['trn_date'] = this.txn_Invoice.issueDate;
    this.printVariables['trn_desc'] = this.txn_Invoice.issue_remark;
    this.printVariables['trn_discount'] = this.txn_Invoice.discount_amount;
    this.printVariables['payable_amount'] = this.txn_Invoice.payable_amount;
    this.printVariables['student_account'] = this.txn_Invoice.relatedAccount;
    this.txn_DR.GL_Code = '';
    // reset transaction values.
    this.txn_Invoice.inv_amount = null;
    this.txn_Invoice.discount_amount = 0;
    this.txn_Invoice.issueDate = new Date();
    this.txn_Invoice.issue_remark = '';
    this.txn_Invoice.relatedAccount = '';
    this.txn_Invoice.semester = null;
  }

  ngOnInit() {
    Array.from({ length: 30 }, (x, i) => this.years.push(i + 1380));
    this.form = new FormGroup({
      AccountControl: new FormControl('', [Validators.required]),
      txnAmountFormControl: new FormControl(),
      txnDiscountFormControl: new FormControl(),
      txnSemesterFormControl: new FormControl(),
      txnRemarksFormControl: new FormControl(),
      txnIssueDateFormControl: new FormControl(),
      txnExpiryDateFormControl: new FormControl(),
      txnYearFormControl: new FormControl(),
      txnAmountPaidAbleFormControl: new FormControl(),
      txtissueremarkFormControl: new FormControl(),
      txtinstallNumberFormControl: new FormControl(),
    });

    this.getLabels();

    let maps$: Observable<Object> = this.AccountMapService.getAccountMapping('student-invoice');
    //let gl_childs$: Observable<Object> = maps$.mergeMap(maps => {
    //  this.ArrAccountMaps = maps;
    //  this.MasterAccDR = this.ArrAccountMaps.find((o: any) => o.component === 'student-invoice' && o.drcr === 'D' && o.trnCode === 'AAT').masterAcc;
    //  //this.txn_Discount.GL_Code = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice' &&  o.drcr === 'D' && o.trnCode === 'ACT' ).childAcc;
    //  console.log("student Master account-->" + this.MasterAccDR);
    //  return this.GL_MasterService.getGL_Childs(this.MasterAccDR);
    //});
    this.InvoiceService.getInvoiceTypes().subscribe(invoicetypes => {
      console.log(invoicetypes);
      this.invoiceTypes = invoicetypes;
    })
    //gl_childs$.subscribe(stAccounts => {
    //  this.StudentAccounts = stAccounts;
    //  console.log(`student accounts: ${this.StudentAccounts}`);
    //  //this.filteredOptions = this.AccountControl.valueChanges
    //  this.filteredOptions = this.form.controls['AccountControl'].valueChanges
    //    .pipe(
    //      startWith(''),
    //      map(value => this._filter(value)
    //      ))
    //});


    this.getDebitAccounts();
    this.getBranchId();
    this.getAmounts();
  }
  is_allow_save: boolean = true;
  isBranchId: number = -1;
  userId: string ="";
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
      this.userId = dataAccessUrl.userId
    }
    this.fee.branchId = this.isBranchId
  }

  fixAmount: FixAmount; 
  getAmounts() {
    this.UtilityService.getFixAmount("0")
      .subscribe(response => {
        if (response) {
          this.fixAmount = response as FixAmount;
          //this.ArrLabels = response;
          //this.setLabels();
        }
      },
        error => console.log(error))
  } 

  searchStudent() {
    let a = $('input[id="studentAccountID"]').val();
    this.GL_MasterService.getStudentName(a).subscribe(
      result => {
        if (result) {
          this.studentName = result.json();
          if (this.studentName != undefined && (this.studentName.udF2 != this.isBranchId && this.isBranchId > 0)) {
            this.snackBar.open(null, 'شما دسترسی به این شعبه ندارید', {
              duration: 500,
            });
            this.is_allow_save = false;
            return;
          } else {
            this.is_allow_save = true;
          }
          console.log("Dont't do it! ");
          console.log(this.studentName);
          this.GL_MasterService.getStudentDetails(this.studentName["gL_ChildCode"], this.txn_Invoice.semester).subscribe(
            result => {
              console.log("Test for cards: ");
              console.log(result);
              if (result) {
                 
                this.studentDetails = result.json();                
                //this.printVariables['transferFromSemester'] = this.invoiceList[inv].transferFromSemester;          
                let arrayItem = this.studentDetails.installmentNumbers.split(',');
                if (!this.IsRepeatSemester) {
                  for (var i = 0; i < this.checkbox_list.length; i++) {
                    let id = this.checkbox_list[i].id;
                    if (arrayItem.find(x => x == id)) {
                      this.checkbox_list[i].disabled = true;
                    }
                  }
                }

                this.fee.newSemester = this.txn_Invoice.semester;
                this.fee.studentId = this.txn_Invoice.relatedAccount;
                this.fee.isRepeatedSemeter = this.IsRepeatSemester;
                this.fee.repeatSemesterSerie = this.RepeatSemesterSerie;
                this.FeeService.getFeeA(this.fee).subscribe(r => {
                  this.fee.semester = r["semester"] + "";
                  this.fee.fieldID = r["fieldID"] + "";
                  this.fee.season = r["season"] + "";
                  this.fee.year = r["year"] + "";
                  this.fee.departmentName = r["departmentName"] + "";
                  this.feeAmount = r["feeAmount"] + "";

                  console.log("Last Fees: ");
                  console.log(r);
                  console.log(this.fee.fieldID);
                  console.log("Fee Amount: " + this.feeAmount);
                  this.setInstallmentMonth(r["installmentNumbers"]);
                  this.FeeService.getOldFees(this.studentName["gL_ChildCode"], this.fee.semester).subscribe(r => {
                    this.oldFees = r;
                    console.log("invoices: " + r);
                    console.log(r);
                  });
                });
              }
            }
          );
        } else {
          this.openSnackBar(null, 'محصل یافت نشد');
        }
      }
    );
  }

  showPopup() {
    const dialogRef = this.dialog.open(PaidFeesModalComponent, {
      width: '560px',
      data: { semester: this.fee.semester, department: this.fee.departmentName, season: this.fee.season, year: this.fee.year, fees: this.oldFees, feeAmount: this.feeAmount }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("Modal Close");
    });
  }

  getInvoice(inv_no: string) {
    this.InvoiceService.getInvoice(this.txn_Invoice.trn_ref_issue)
      .subscribe(response => {
         
        this.invoiceList = response;
        console.log(`list of invoices: ` + response);
         
        for (let inv in this.invoiceList) {
          console.log(this.invoiceList[inv].gL_ChildDesc);
          console.log(`invoice type Desc: ` + this.invoiceList[inv].invoiceDesc);
          console.log(`invoice type: ` + this.invoiceList[inv].invoiceType);
          // replace date with dari farmat.
          if (this.invoiceList[inv].issueDate)
            this.invoiceList[inv].issueDate_da = this.DariCalendar.PersianCalendar(new Date(this.invoiceList[inv].issueDate));
          if (this.invoiceList[inv].clearDate)
            this.invoiceList[inv].clearDate_da = this.DariCalendar.PersianCalendar(new Date(this.invoiceList[inv].clearDate));
          if (this.invoiceList[inv].expiryDate)
            this.invoiceList[inv].expiryDate_da = this.DariCalendar.PersianCalendar(new Date(this.invoiceList[inv].expiryDate));
          this.printVariables['inv_no'] = this.invoiceList[inv].inv_no;
          this.printVariables['trn_amount'] = this.invoiceList[inv].inv_amount;
          this.printVariables['trn_date'] = this.invoiceList[inv].issueDate_da;
          this.printVariables['trn_desc'] = this.invoiceList[inv].issue_remark;
          this.printVariables['trn_discount'] = this.invoiceList[inv].discount_amount;
          this.printVariables['payable_amount'] = this.invoiceList[inv].payable_amount;
          this.printVariables['student_account'] = this.invoiceList[inv].relatedAccount;
          this.printVariables['gL_ChildDesc'] = this.invoiceList[inv].gL_ChildDesc;          
          this.printVariables['trn_ref_no'] = this.invoiceList[inv].trn_ref_issue;
          this.printVariables['CheckerID'] = this.invoiceList[inv].CheckerID;
          this.printVariables['expDate'] = this.invoiceList[inv].expiryDate_da;
          this.printVariables['semester'] = this.invoiceList[inv].semester;
          this.printVariables['udF2'] = this.invoiceList[inv].udF2;
          this.printVariables['udF3'] = this.invoiceList[inv].udF3;
          this.printVariables['months'] = this.invoiceList[inv].installmentNumber;
          this.printVariables['department'] = this.invoiceList[inv].department;
          this.printVariables['invoiceDesc'] = this.invoiceList[inv].invoiceDesc;
          this.isPrintable = this.invoiceList[inv].invoiceDesc == 'هزینه چانس' ||
          this.invoiceList[inv].invoiceDesc == 'هزینه داخله' ||
          this.invoiceList[inv].invoiceDesc == 'فیس سمستر';
          this.printVariables['bankAccountNameFa'] = this.invoiceList[inv].bankAccountNameFa;
          this.printVariables['bankAccountNumber'] = this.invoiceList[inv].bankAccountNumber;
          this.printVariables['installmentNumber'] = this.invoiceList[inv].installmentNumber;
          this.printVariables['installmentNumbers'] = this.invoiceList[inv].installmentNumbers;
          this.isFeeSemester = this.invoiceList[inv].invoiceDesc == 'فیس سمستر';
          this.printVariables['trn_discountValue'] = this.invoiceList[inv].discount_amount;
          this.printVariables['trn_discount'] = this.txn_Invoice.discount_amount;
          this.printVariables['feeTitle'] = (this.invoiceList[inv].invoiceDesc == 'فیس سمستر') ? "فیس ماهوار" : "مبلغ فیس";
          ///debugger;
          //this.printVariables['trn_discount'] = (parseInt(this.invoiceList[inv].discount_amount) * 100) / (parseInt(this.invoiceList[inv].discount_amount) + parseInt(this.invoiceList[inv].payable_amount));
          this.printVariables['name'] = this.invoiceList[inv].gL_ChildDesc.split("ولد")[inv];
          this.printVariables['fname'] = this.invoiceList[inv].gL_ChildDesc.split("ولد")[1];
        }
      });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.StudentAccounts.filter(option => option.gL_ChildCode.toLowerCase().includes(filterValue));
  }

  getDebitAccounts() {
    this.GL_MasterService.getGL_Childs('B00001', this.isBranchId)
      .subscribe(response => {
        if (response) {
          this.DebitAccounts = response;
        }
      },
        error => console.log("error --> " + error))
  }

  AccountChanged(event, gL_ChildDesc, gL_ChildCode) {

    console.log(event.isUserInput);
    if (event.isUserInput === true) {
      console.log(gL_ChildDesc);
      this.selectedAccountName = gL_ChildDesc;

    }
  }

  invoiceTypeSelect(event: MatSelectChange) {
    this.selectedInvoiceType = event.value;
    console.log(`selected invoice type: ` + this.selectedInvoiceType);
     
    if (this.selectedInvoiceType == 'Fee') {
      let ii = this.txn_DR.GL_Code;

      this.GL_MasterService.getStudentDetails(this.studentName["gL_ChildCode"], this.txn_Invoice.semester).subscribe(r => {
        //this.txn_Invoice.inv_amount = r[];
        //this.txn_Invoice.discount_amount
        //this.txn_Invoice.semester = ,
        this.txn_Invoice.semester = r.json().lastSemester;
        this.txn_Invoice.year = r.json().year;
        this.txn_Invoice.season = r.json().season;
        this.form.controls['txnRemarksFormControl'].setValue(r.json().season);
        this.form.controls['txnYearFormControl'].setValue(r.json().year);
        //$(`mat-option[value=${this.txn_Invoice.season}]`).selected(true);---------
        this.fee.fieldID = r.json().department;
        this.fee.year = r.json().year;
        this.fee.season = r.json().season;
        // بخاطر اینکه گفتن از ترم یک تا ترم آخر مقدار فیس ثابت هست..
        this.fee.semester = "1"; // r.json().lastSemester;

        if (this.fee.fieldID == "500" && parseInt(this.fee.semester) <= 10) {
          //if (this.insNumber.length == 6)
          //  this.insNumber.pop();
          this.checkbox_list[5].disabled = true;

        } else {
          this.checkbox_list[5].disabled = false;
        }

        if (this.fee.fieldID == "600" && parseInt(this.fee.semester) <= 12) {
          //if (this.insNumber.length == 6)
          //  this.insNumber.pop();
          this.checkbox_list[5].disabled = true;
        } else {
          this.checkbox_list[5].disabled = false;
        }
        this.fee.newSemester = this.txn_Invoice.semester;
        this.fee.studentId = this.txn_Invoice.relatedAccount;
        this.fee.isRepeatedSemeter = this.IsRepeatSemester;
        this.fee.repeatSemesterSerie = this.RepeatSemesterSerie;
        this.FeeService.getFeeA(this.fee).subscribe(r => {
          this.feeGet = r;
          console.log(this.feeGet);
          this.txn_Invoice.inv_amount = this.feeGet.feeAmount;
          this.setInstallmentMonth(this.feeGet.installmentNumbers);
        });
        this.DiscountService.getDiscountA(this.studentName["gL_ChildCode"]).subscribe(r => {
          this.txn_Invoice.discount_amount = r["discountAmount"];
          $('#discPercent').val(this.txn_Invoice.discount_amount)
          console.log(this.txn_Invoice.discount_amount);
        });
        //$('#seasonDrp').children('option')
        //console.log(r.json().year);
        //console.log("seasson"+this.txn_Invoice.season);
        //console.log("seassonDrp" + $('#seasonDrp').val());
        //console.log(r.json().lastSemester);
      });
    } else if (this.selectedInvoiceType == "AttendanceFail") {
      this.paymentInMonth = this.fixAmount.feeNonPrecent.toString();
    } else if (this.selectedInvoiceType == "Chance") {
      this.paymentInMonth = this.fixAmount.feeChanse.toString();
    }
    else if (this.selectedInvoiceType == "CreditSelectionAgain") {
      this.paymentInMonth = this.fixAmount.feeReCredit.toString();
    }
    else if (this.selectedInvoiceType == "Entry") {
      this.paymentInMonth = this.fixAmount.feeEntry.toString();
    }
    else if (this.selectedInvoiceType == "IDCARD") {
      this.paymentInMonth = this.fixAmount.feeIdCard.toString();
    }
    else if (this.selectedInvoiceType == "Monograph") {
      this.paymentInMonth = this.fixAmount.feeMonograph.toString();
    }
    else if (this.selectedInvoiceType == "MonographAgain") {
      this.paymentInMonth = this.fixAmount.feeReMonograph.toString();
    }
    else if (this.selectedInvoiceType == "Penalty") {
      this.paymentInMonth = this.fixAmount.feeStuAmerce.toString();
    }

  }

  CheckReapetedSemester(checkbox) {
     
    let value = checkbox.checked;
    this.IsRepeatSemester = value;
    this.SemeterChange();
  }

  CheckReapetedSemesterSerie(item) {
     
    let value = item.value;
    this.RepeatSemesterSerie = value;
    this.SemeterChange();
  }

  

  SemeterChange() {
    if (this.selectedInvoiceType == 'Fee') {
      //this.fee.year = this.txn_Invoice.year;
      //this.fee.semester = this.txn_Invoice.semester.toString();
      this.fee.season = this.txn_Invoice.season;
      //this.GL_MasterService.getStudentDetails(this.studentName["gL_ChildCode"], this.txn_Invoice.semester).subscribe(r => {
      //  let data: any = r;

      //});
      this.fee.newSemester = this.txn_Invoice.semester;
      this.fee.studentId = this.txn_Invoice.relatedAccount;
      this.fee.repeatSemesterSerie = this.RepeatSemesterSerie
      this.fee.isRepeatedSemeter = this.IsRepeatSemester
      this.FeeService.getFeeA(this.fee).subscribe(r => {
        this.feeGet = r;
        console.log(this.feeGet);
        this.txn_Invoice.inv_amount = this.feeGet.feeAmount;
        this.setInstallmentMonth(this.feeGet.installmentNumbers);
        this.PaymentInMonthChange(null);
      });
      this.DiscountService.getDiscountA(this.studentName["gL_ChildCode"]).subscribe(r => {
        this.txn_Invoice.discount_amount = r["discountAmount"];
        $('#discPercent').val(this.txn_Invoice.discount_amount)
        console.log(this.txn_Invoice.discount_amount);
      });

    } else {
      //this.PaymentInMonthChange(null);
    }
  }


  setInstallmentMonth(value: any) {
    if (value == null)
      return;

    let arrayItem = value.split(',');
    
      for (var i = 0; i < this.checkbox_list.length; i++) {
        let id = this.checkbox_list[i].id;
        if (arrayItem.find(x => x == id)) {
          this.checkbox_list[i].disabled = true;
        } else {
          this.checkbox_list[i].disabled = false;
        }
      }    
  }


  checkbox_list = [
    {
      id: 1,
      name: "قسط اول",
      disabled: false,
    },
    {
      id: 2,
      name: "قسط دوم",
      disabled: false,
    },
    {
      id: 3,
      name: "قسط سوم",
      disabled: false,
    },
    {
      id: 4,
      name: "قسط چهارم",
      disabled: false,
    },
    {
      id: 5,
      name: "قسط پنجم",
      disabled: false,
    },
    {
      id: 6,
      name: "قسط ششم",
      disabled: true,
    }]

  PaymentInMonthChange($event: any) {

    let inv_amount = 0;
    let discount_amount = 0;
    let semester = 0;
    let percentDiscount = 0;
    let fieldID = "";
    let mounthArray = $event.value;
    let installmentNumberCount = mounthArray.length;
    this.txn_Invoice.installmentNumbers = mounthArray.join(',');
    if (this.fee.fieldID != undefined)
      fieldID = this.fee.fieldID;
    if (this.txn_Invoice.semester != undefined)
      semester = this.txn_Invoice.semester;
    if ($event != undefined && $event != null) {
      //installmentNumberCount = $event.value;
      this.txn_Invoice.installmentNumber = installmentNumberCount;
    }
    else {
      //installmentNumberCount = this.txn_Invoice.installmentNumber;
    }

    let currentMounth = 0;
    let currentMonthTitle = '';
    for (var i = 0; i < mounthArray.length; i++) {
      currentMounth = mounthArray[i];
      if (currentMounth == 1)
        currentMonthTitle = "اول";
      if (currentMounth == 2)
        currentMonthTitle += "," + "دوم";
      if (currentMounth == 3)
        currentMonthTitle += "," + "سوم";
      if (currentMounth == 4)
        currentMonthTitle += "," + "چهارم";
      if (currentMounth == 5)
        currentMonthTitle += "," + "پنجم";
      if (currentMounth == 6)
        currentMonthTitle += "," + "ششم";
    }
    this.printVariables['installmentMonthTitle'] = currentMonthTitle;
    if (this.txn_Invoice.inv_amount != undefined)
      inv_amount = this.txn_Invoice.inv_amount;
    else
      inv_amount = 0;
    if (this.txn_Invoice.discount_amount != undefined)
      discount_amount = this.txn_Invoice.discount_amount;
    let discountValue = 0;
    if (this.selectedInvoiceType == 'Fee') {

      if (installmentNumberCount > 0 && inv_amount > 0 && semester > 0) {
        let payinMonth = inv_amount;
        this.printVariables['trn_amount_mounth'] = payinMonth;

        if (discount_amount > 0)
          discountValue = (payinMonth * installmentNumberCount) * discount_amount / 100;

        let finalAmount = payinMonth * installmentNumberCount; // - discountValue;
        this.paymentInMonth = finalAmount.toString();
        this.paymentByDiscount = (finalAmount - discountValue).toString();
      } else {
        this.paymentInMonth = "0";
      }
    } else {
      let finalAmount = parseInt(this.paymentInMonth);
      if (discount_amount > 0)
        discountValue = finalAmount * discount_amount / 100;

      this.paymentByDiscount = (finalAmount - discountValue).toString();
    }


    this.printVariables['trn_discount'] = discount_amount;
    //this.printVariables['trn_desc'] = this.txn_Invoice.issue_remark;
    if (this.selectedInvoiceType == "Fee") {
      this.printVariables['feeTitle'] = "فیس ماهوار";
      this.isFeeSemester = true;
    } else {
      this.isFeeSemester = false;
      this.printVariables['feeTitle'] = "مبلغ فیس";
    }
  }

  DebitAccountChanged(event, gL_ChildCode, gL_ChildDesc) {
    console.log(event.isUserInput);
    if (event.isUserInput === true) {
      this.prntSelectedBankAccount = gL_ChildDesc;
      this.prntSelectedBankNumber = gL_ChildCode;
    }
  }

  submit(a: string) {
     
    if (a == 'submit') {

      if (!this.is_allow_save) {
        this.openSnackBar(null, 'شما دسترسی به اطلاعات این دانشجو ندارید');
        return;
      }

       
      if (this.prntSelectedBankNumber == undefined || this.prntSelectedBankNumber == null || this.prntSelectedBankAccount == undefined || this.prntSelectedBankAccount ==null) {
        this.openSnackBar(null, 'لطفا اکانت دبیت را انتخاب کنید');
        return
      }

      if (this.paymentInMonth == undefined || this.paymentInMonth == '0') {
         
        this.openSnackBar(null, 'مقدار تعریفه نمی تواند خالی باشد');
        return
      }

      if (this.paymentByDiscount == undefined || this.paymentByDiscount == '0') {
         
        this.openSnackBar(null, 'مقدارقابل پرداخت نمی تواند خالی باشد');
        return
      }

      if ((this.txn_Invoice.semester == undefined || this.txn_Invoice.semester == 0) && this.selectedInvoiceType != "Entry" ) {
         
        this.openSnackBar(null, 'مقدار سمستر نمی تواند خالی باشد');
        return
      }

      if (this.userId == undefined ) {
         
        this.openSnackBar(null, 'لطفا دوباره وارد سیستم شوید');
        this.router.navigateByUrl('/login')
        return
      }

      if (this.isBranchId == -1 ) {
         
        this.openSnackBar(null, 'لطفا خارج شده دوباره وارد سیستم شوید');
        return
      }


      //|| this.txn_Invoice.payable_amount || this.txn_Invoice.payable_amount == 0

      this.txn_Invoice.isRepeatSemester = this.IsRepeatSemester;
      this.txn_Invoice.repeatSemesterSerie = this.RepeatSemesterSerie;
      this.txn_Invoice.userId = this.userId;
      this.txn_Invoice.branchId = this.isBranchId.toString();

      this.txn_Invoice.inv_amount = parseInt(this.paymentInMonth);
      debugger;
      console.log('discount tttt');
      console.log(this.txn_Invoice.discount_amount);
      this.txn_Invoice.discountValue = this.txn_Invoice.discount_amount;
      var gdate_issueDate = new Date(this.datepipe.transform(this.txn_Invoice.issueDate, 'yyyy-MM-dd'));
      this.txn_Invoice.issueDate = gdate_issueDate;
      var gdate_expiryDate = new Date(this.datepipe.transform(this.txn_Invoice.expiryDate, 'yyyy-MM-dd'));
      this.txn_Invoice.expiryDate = gdate_expiryDate;
      this.txn_Invoice.invoiceType = this.selectedInvoiceType;
      console.log(`expiry date: ` + this.txn_Invoice.expiryDate);
      //console.log (`invoice type: ` + this.invoiceTypeOptions);
      console.log('txn invoice:');
      console.log(this.txn_Invoice);
      this.Txn_DE_Service.CreateTxn_Invoice(this.txn_Invoice, this.prntSelectedBankAccount, this.prntSelectedBankNumber)
        .subscribe(response => {
          if (response) {
            console.log(response);
            this.txn_result = response.json();
            this.arr_results['result'] = this.txn_result.find((o: any) => o.key === 'result').value;
            this.arr_results['trn_ref_no'] = this.txn_result.find((o: any) => o.key === 'trn_ref_no').value;
            this.arr_results['inv_no'] = this.txn_result.find((o: any) => o.key === 'inv_no').value;
            if (this.arr_results['result'] == 'success') {
              this.txn_Invoice.trn_ref_issue = this.arr_results['trn_ref_no'];
              console.log('transaction succeed. trn_ref_no --> ' + this.arr_results['trn_ref_no']);
              this.getInvoice(this.arr_results['trn_ref_no']);
              this.resetTrns();
              console.log(this.txn_Invoice);
              console.log('lkjlkjlkj--->>  ' + this.arr_results['trn_ref_no']);
              this.openSnackBar(this.arr_results['trn_ref_no'], 'چاپ');
            }
            else {
              console.log('transaction failed: ' + this.arr_results['result']);
              this.openSnackBar(this.arr_results['result'], '');
            }
          }
        },
          error => {
            console.log(error);
            this.openSnackBar(null, 'خطا در ثبت');
          }
        );
    }
  }

  trnDateChanged(type: string, event: MatDatepickerInputEvent<Date>) {
    //console.log(`${type}: ${event.value}` );
    this.pdate = moment(event.value).format('jYYYY-jMM-jDD');
    this.txn_Invoice.issueDate = moment(event.value).toDate();
    console.log(this.txn_Invoice.issueDate);
  }

  trnExpiryDateChanged(type: string, event: MatDatepickerInputEvent<Date>) {
    //console.log(`${type}: ${event.value}` );
    this.pdate = moment(event.value).format('jYYYY-jMM-jDD');
    this.txn_Invoice.expiryDate = moment(event.value).toDate();
    console.log(`expriy date changed: ` + this.txn_Invoice.expiryDate);
  }

  openSnackBar(message: string, action: string) {

    let snackBarRef = this.snackBar.open(message, action, {
      duration: 2000,
    });
    snackBarRef.dismissWithAction = function () {
      if (this.selectedInvoiceType == "fee") {
        this.isFeeSemester = true;
      } else {
        this.isFeeSemester = false;
      }

      //------------------------------------------
      console.log("lkjlkj---oooo: " + this.invoiceList);

      //-------------------------------------------
      console.log('inside snack bar')
      snackBarRef.dismiss();
      var content = $("#print-section").prop('outerHTML');
      var printWindow = window.open('', '', '');
      printWindow.document.write('<html><head><title>Print</title>');
      var _link = $('link');
      var _style = $('style');
      var strstyle = '';
      var _script = $('script');
      for (var k = 0; k < _link.length; k++)
        printWindow.document.write(_link[k].outerHTML);
      for (var i = 0; i < _style.length; i++)
        printWindow.document.write(_style[i].outerHTML);
      for (var j = 0; j < _script.length; j++)
        printWindow.document.write(_script[j].outerHTML);
      printWindow.document.write('</head><body  style="-webkit-print-color-adjust: exact;     margin-top: 1px;"  >');
      printWindow.document.write(content);
      printWindow.document.write('<script> $(".AES").css("display", "block");</script> </body ></html>');
      printWindow.document.close();
      //setTimeout(() => { printWindow.print(); }, 4000);
    }
  }
  // snackBarRef.afterDismissed().subscribe(null, null, () => {
  //   console.log('dismissed');
  // })

  // getAccountMaps()
  // {
  //   this.AccountMapService.getAccountMapping('student-invoice')
  //     .subscribe(response => {
  //       if (response){
  //         this.ArrAccountMaps = response;
  //         this.setMaps();
  //       }
  //     },
  //     error => console.log("error --> " + error))
  // }

  // setMaps() {

  //   this.txn_CR.GL_Code = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice' &&  o.drcr === 'C' ).childAcc;
  //   this.MasterAccDR = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice' &&  o.drcr === 'D'  && o.trnCode === 'AAT' ).masterAcc;
  //   this.txn_Discount.GL_Code = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice' &&  o.drcr === 'D' && o.trnCode === 'ACT' ).childAcc;
  //   console.log(this.MasterAccDR);
  // }


  // AccountChanged(event)
  // {
  //   this.selectedAccountName = event.source.triggerValue
  // }
  getLabels() {
    this.UtilityService.getLabels('student-invoice', this.global.lang)
      .subscribe(response => {
        if (response) {
          this.ArrLabels = response;
          this.setLabels();
        }
      },
        error => console.log(error));
    this.UtilityService.getLabels('student-invoice-clear', this.global.lang)
      .subscribe(response => {
        if (response) {
          this.ArrLabels1 = response;
          this.setLabels();
        }
      },
        error => console.log(error))
  }

  getLabels1() {

  }

  setLabels() {

    this.labels['debitAccount'] = this.ArrLabels1.find((o: any) => o.key === 'debitAccount').value;

    if (this.ArrLabels != undefined && this.ArrLabels.length > 0) {
      return;
    }
    //title
    this.labels['student-invoice-Title'] = this.ArrLabels.find((o: any) => o.key === 'student-invoice-Title').value;

    // labels
    this.labels['StudentAccount'] = this.ArrLabels.find((o: any) => o.key === 'StudentAccount').value;
    this.labels['ValueDate'] = this.ArrLabels.find((o: any) => o.key === 'ValueDate').value;
    this.labels['TrnAmount'] = this.ArrLabels.find((o: any) => o.key === 'TrnAmount').value;
    this.labels['TrnDiscount'] = this.ArrLabels.find((o: any) => o.key === 'TrnDiscount').value;
    this.labels['trnRemakrs'] = this.ArrLabels.find((o: any) => o.key === 'trnRemakrs').value;
    this.labels['trnSemester'] = this.ArrLabels.find((o: any) => o.key === 'trnSemester').value;


    // Alerts
    this.labels['StudentAccountMandatory'] = this.ArrLabels.find((o: any) => o.key === 'StudentAccountMandatory').value;
    this.labels['ValueDateMandatory'] = this.ArrLabels.find((o: any) => o.key === 'ValueDateMandatory').value;
    this.labels['TrnAmountMandatory'] = this.ArrLabels.find((o: any) => o.key === 'TrnAmountMandatory').value;
    this.labels['TrnDiscountMandatory'] = this.ArrLabels.find((o: any) => o.key === 'TrnDiscountMandatory').value;
    this.labels['TrnSemesterMandatory'] = this.ArrLabels.find((o: any) => o.key === 'TrnSemesterMandatory').value;
    this.labels['ExpiryDate'] = this.ArrLabels.find((o: any) => o.key === 'ExpiryDate').value;


    // shared labels.
    this.labels['RecordStat'] = this.ArrLabels.find((o: any) => o.key === 'RecordStat').value;
    this.labels['AuthStat'] = this.ArrLabels.find((o: any) => o.key === 'AuthStat').value;
    this.labels['CreateDate'] = this.ArrLabels.find((o: any) => o.key === 'CreateDate').value;
    this.labels['CheckerID'] = this.ArrLabels.find((o: any) => o.key === 'CheckerID').value;
    this.labels['MakerID'] = this.ArrLabels.find((o: any) => o.key === 'MakerID').value;

  }
}



// WEBPACK FOOTER //
// ./src/app/components/TRNs/student-invoice/student-invoice.component.ts